// assets
import { IconUsers, IconCalendarStats, IconCoin, IconReceipt } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - HR (P4-1) ||============================== //

const hr: NavItemType = {
  id: 'hr',
  title: 'hr', // react-intl key - i18n-ready [STD-DRIFT]
  icon: IconUsers,
  type: 'group',
  requiredModule: 'hr',
  children: [
    {
      id: 'hr-employees',
      title: 'hr-employees',
      icon: IconUsers,
      type: 'item',
      url: '/hr/employees',
      module: 'hr.employees'
    },
    {
      id: 'hr-leave',
      title: 'hr-leave',
      icon: IconCalendarStats,
      type: 'item',
      url: '/hr/leave',
      module: 'hr.leave'
    },
    {
      id: 'hr-payroll',
      title: 'hr-payroll',
      icon: IconCoin,
      type: 'item',
      url: '/hr/payroll',
      module: 'hr.payroll'
    },
    {
      id: 'hr-expenses',
      title: 'hr-expenses',
      icon: IconReceipt,
      type: 'item',
      url: '/hr/expenses',
      module: 'hr.expenses'
    }
  ]
};

export default hr;
